import { createSlice } from "@reduxjs/toolkit";

const initialState = { isOpen: true, expandedTabs: {} };

const profileSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarOpen(state, action) {
      state.isOpen = action.payload;
    },
    setExpandedTabs(state, action) {
      state.expandedTabs = action.payload;
    },
  },
});

export const { setSidebarOpen, setExpandedTabs } = profileSlice.actions;

export default profileSlice.reducer;
